module.exports = {"id":"205850","name":"Leonardo Pavoletti","rating":"77","photo":"./data/images/photos/2/205850.png","club":{"name":"Cagliari","logo":"./data/images/clubs/Cagliari.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeonardoPavoletti0.json
// module id = 2489
// module chunks = 0